var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 6.00033H23.3337V16.667C23.3337 17.4003 22.7337 18.0003 22.0003 18.0003H6.00033V19.3337C6.00033 20.8003 7.20033 22.0003 8.66699 22.0003H22.0003L27.3337 27.3337V8.66699C27.3337 7.20033 26.1337 6.00033 24.667 6.00033ZM20.667 12.667V3.33366C20.667 1.86699 19.467 0.666992 18.0003 0.666992H3.33366C1.86699 0.666992 0.666992 1.86699 0.666992 3.33366V20.667L6.00033 15.3337H18.0003C19.467 15.3337 20.667 14.1337 20.667 12.667Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBlue);
export default __webpack_public_path__ + "static/media/chatBlue.1cb7d38c26b482e15dc90d3f331d1bf5.svg";
export { ForwardRef as ReactComponent };